"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (r, idx, ruleLookup) => {
    switch (r.successors.kind) {
        case "all":
            return ruleLookup[r.successors.rule];
        case "none":
            return null;
        case "specific":
            const possibleRule = r.successors.rules[idx];
            if (possibleRule) {
                return ruleLookup[possibleRule];
            }
            else {
                return null;
            }
    }
};



// WEBPACK FOOTER //
// ./src/components/three/ruleToApply.ts